import { UpdateUserDefinition } from "@super-real/types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const updateUserCallable = getCallable(UpdateUserDefinition);
